import { DownloadMultipleIcon } from './DownloadMultipleIcon';

/**
 * author: GreenTurtwig
 * id EEECC393-B78C-43DE-BDA4-F31DACA25F56
 * name download-multiple
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/download-multiple.svg
 * tags
 */
export const DownloadsIcon = DownloadMultipleIcon;
export default DownloadsIcon